import axios from "axios";
import router from "../router";
import { ElMessage } from "element-plus";
// import { ElMessageBox } from "element-plus";
import store from "../store";

const service = axios.create({
  timeout: 6000,
  // baseURL: "http://localhost:8081",
  // 本地nginx代理
  // baseURL: "http://localhost:8089",
  // 华为云nginx代理
  baseURL: "http://123.249.36.222:8089",
  // 腾讯云nginx代理
  // baseURL: "http://49.234.18.156:8089",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    "token": localStorage.getItem("token"),
  },
});

// 上传文件
const serviceUploadFile = axios.create({
  timeout: 60000,
  // baseURL: "http://localhost:8081",
  // baseURL: "http://49.234.18.156:8089",
  baseURL: "http://123.249.36.222:8089",
  withCredentials: true,
  headers: {
    // "Content-Type": "multipart/form-data;boundary=----WebKitFormBoundaryrGKCBY7qhFd3TrwA",
    // "Content-Type": "multipart/form-data",
    "token": store.getters.getToken,
  },
});

// 下载文件
const serviceFileContext = axios.create({
  timeout: 6000,
  // baseURL: "http://localhost:8089",
  // baseURL: "http://49.234.18.156:8089",
  baseURL: "http://123.249.36.222:8089",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    // "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    "token": localStorage.getItem("token"),
  },
});

// request前置拦截器
service.interceptors.request.use(
  (config) => {
    // console.log(config);
    return Promise.resolve(config);
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response拦截器
service.interceptors.response.use(
  (response) => {
    let res = response.data;
    if (res.code === 200) { // 200
      return Promise.resolve(response);
    } else if (parseInt(res.code / 100) == 2) { // 2xx
      ElMessage.info(res.message, {
        duration: 3 * 1000,
      });
      return Promise.resolve(response);
      // return Promise.reject(response);
    } else if (parseInt(res.code / 100) == 5) { // 5xx
      ElMessage.error(res.message, {
        duration: 3 * 1000,
      });
      return Promise.reject(response);
    }
    // if (res.code === 200) {
    //   if (res.message != null && res.message != "") {
    //     ElMessage.success(res.message, {
    //       duration: 3 * 1000,
    //     });
    //   }

    //   return Promise.resolve(response);
    // } else if (res.code === 204) {
    //   ElMessage.info(res.message, {
    //     duration: 3 * 1000,
    //   });
    //   return Promise.resolve(response);
    // } else {
    //   ElMessage.error(res.message, {
    //     duration: 3 * 1000,
    //   });
    //   return Promise.reject(response);
    // }

  },
  // 无响应时的处理
  (error) => {
    let res = error.data;
    // 权限验证过期
    if (res.code) {
      switch (res.code) {
        // 未登录
        case 401:
          router.replace({
            path: "/",
            query: {
              redirect: router.currentRoute.fullPath,
            }
          })
          break;
        // 未找到
        case 404:
          break;
      }
    }
    if (res.message) {
      ElMessage.error(res.message, {
        duration: 3 * 1000,
      });
    }

    return Promise.reject(error);
  }
);

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, { params: params })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export function postByFileDevice(url, data = {}) {
  return new Promise((resolve, reject) => {
    serviceFileContext.post(url, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      })
  });
}

export function uploadPost(url, data = {}) {
  return new Promise((resolve, reject) => {
    serviceUploadFile.post(url, data)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      })
  });
}


export { service, serviceUploadFile };
